// El botón que abre el Brain, presente en toda la aplicación (2.1, D1, 1.2).
//
// **Va en una esquina y no en el menú.** En escritorio no hay barra superior
// —el armazón son dos columnas—, así que los únicos sitios siempre visibles
// eran el menú lateral y una esquina fija. El menú se descartó porque en móvil
// son dos toques —abrirlo y tocar—, que es justo lo que este plan quita.
//
// **Abajo a la derecha está libre**: las barras flotantes que ya existen
// —Knowledge y Herramientas— van abajo **al centro** y a `z-30`. Este sube a
// `z-40` para quedar por encima de ellas y por debajo de los diálogos, que
// están en `z-50`: mientras hay un diálogo abierto, nada de fuera compite.
//
// **Solo abre.** Cerrar es la X del panel, y no las dos cosas: cuando el botón
// también cerraba había dos controles con el mismo nombre en pantalla, que
// para quien navega con lector es la misma orden repetida sin saber cuál es
// cuál. Quien lo tiene abierto ya tiene su salida delante.

import { Brain } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

export function BrainLauncher({ onAbrir }: { onAbrir: () => void }) {
  const { t } = useTranslation()

  return (
    <Button
      size="icon"
      aria-label={t('brain.panel.abrir')}
      onClick={onAbrir}
      className="fixed bottom-[calc(1.5rem+env(safe-area-inset-bottom))] right-6 z-40 rounded-full shadow-md"
    >
      <Brain className="h-5 w-5" />
    </Button>
  )
}
